import { AdminArticles } from './AdminArticles'

export default AdminArticles